import React, { useState } from 'react';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import Layout from '../components/layout/Layout';

const Support = () => {
  const [FormState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [SubmitDisabled, setSubmitDisabled] = useState(false);

  const handleChange = e => {
    setFormState({
      ...FormState,
      [e.target.name]: e.target.value
    });
  };

  const encode = data => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&');
  };

  const handleSubmit = e => {
    addToMailchimp(
      FormState.email,
      {
        NAMESUPP: FormState.name,
        PHONESUPP: FormState.phone,
        MESSAGE: FormState.message
      },
      'https://kratosgp.us19.list-manage.com/subscribe/post?u=752d0123ff5130e82b58844ed&amp;id=ce4be3be14'
    );
    setSubmitDisabled(true);
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'General Contact', ...FormState })
    })
      .then(() => window.open('../ThankYouGeneral', '_self'))
      .catch(() => window.open('../Error', '_self'));

    e.preventDefault();
  };

  console.log(FormState);

  return (
    <Layout>
      <main class="mt-10 mb-8 md:mb-32 mx-auto max-w-screen-xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 xl:mt-28">
        <div class="text-center">
          <h2 class="text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl">
            Supplier Terms and Conditions
          </h2>
          <p class="mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-xl ">
            Kratos Gas & Power Michigan is happy to help you make the switch to a natural gas
            provider that better fits your needs. Please remember that Kratos does not bill you
            directly for your natural gas service and that most questions, such as billing issues or
            service questions, are best answered by your local utility.
          </p>

          <div class="block mt-5 mx-auto lg:flex lg:justify-center md:mt-8">
            <div class="">
              <a
                href="/terms-conditions-dominion/"
                class="block md:flex mt-3 rounded-lg text-white sm:mt-0 sm:ml-3 sm:flex-shrink-0 bg-red px-14 py-3 hover:bg-darkRed transition ease-in duration-200"
              >
                Dominion East
              </a>
            </div>
            <div class="">
              <a
                href="/terms-conditions-columbia/"
                class="block md:flex mt-3 rounded-lg text-white sm:mt-0 sm:ml-3 sm:flex-shrink-0 bg-red px-14 py-3 hover:bg-darkRed transition ease-in duration-200"
              >
                Columbia Gas
              </a>
            </div>
          </div>
        </div>
      </main>
      <div class="bg-blue">
        <div class="max-w-7xl mx-auto py-16 px-4 sm:px-6">
          <h2 class="pb-10 text-center text-2xl leading-8 font-extrabold text-yellow sm:text-4xl sm:leading-9">
            General Contact
          </h2>
          <div class="max-w-lg mx-auto md:max-w-none md:grid md:grid-cols-2 md:gap-8">
            <div>
              <div class="mt-3">
                <p class="text-base md:text-lg leading-7 text-gray-100">
                  Kratos is happy to help you make the switch to a natural gas provider that better
                  fits your needs. If you have an unrelated general inquiry, feel free to fill out
                  our contact form.
                </p>
              </div>
              <div class="mt-9">
                <div class="mt-12">
                  <h2 class="text-2xl leading-8 font-extrabold text-yellow sm:text-3xl sm:leading-9">
                    Gas Emergency
                  </h2>
                  <div class="mt-3">
                    <p class="text-base md:text-lg leading-7 text-white">
                      To report a gas leak or gas emergency, contact:
                    </p>
                  </div>
                  <div class="mt-9">
                    <div class="flex">
                      <div class="flex-shrink-0">
                        <svg
                          class="h-6 w-6 text-gray-400"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                          />
                        </svg>
                      </div>
                      <div class="ml-3 text-base leading-6 text-fadedYellow">
                        <p>+1 (877) 542-2630</p>
                        <p class="mt-1">Dominion East Ohio</p>
                      </div>
                    </div>
                    <div class="mt-6 flex">
                      <div class="ml-3 text-base leading-6 text-white">
                        <p>www.dominionenergy.com</p>
                      </div>
                    </div>
                  </div>
                  <div class="mt-9">
                    <div class="flex">
                      <div class="flex-shrink-0">
                        <svg
                          class="h-6 w-6 text-gray-400"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                          />
                        </svg>
                      </div>
                      <div class="ml-3 text-base leading-6 text-fadedYellow">
                        <p>+1 (800) 344-4077</p>
                        <p class="mt-1">Columbia Gas Ohio</p>
                      </div>
                    </div>
                    <div class="mt-6 flex">
                      <div class="ml-3 text-base leading-6 text-white">
                        <p>www.columbiagasohio.com</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-blue pt-6 px-4 sm:px-6 ">
              <div class="">
                <form
                  method="POST"
                  target="_self"
                  id="General Contact"
                  name="General Contact"
                  data-netlify="true"
                  data-netlify-honeypot="bot-field"
                  onSubmit={handleSubmit}
                  class="grid grid-cols-1 row-gap-6"
                >
                  <div>
                    <label for="contact_name" class="sr-only">
                      Full name
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <input
                        id="contact_name"
                        name="name"
                        type="text"
                        onChange={handleChange}
                        class="form-input block w-full py-5 px-4 placeholder-gray-500 transition ease-in-out duration-150"
                        placeholder="Full name"
                        required
                      />
                    </div>
                  </div>
                  <div>
                    <label for="contact_email" class="sr-only">
                      Email
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <input
                        id="contact_email"
                        name="email"
                        onChange={handleChange}
                        type="email"
                        class="form-input block w-full py-5 px-4 placeholder-gray-500 transition ease-in-out duration-150"
                        placeholder="Email"
                        required
                      />
                    </div>
                  </div>
                  <div>
                    <label for="contact_phone" class="sr-only">
                      Phone
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <input
                        id="contact_phone"
                        name="phone"
                        type="number"
                        onChange={handleChange}
                        class="form-input block w-full py-5 px-4 placeholder-gray-500 transition ease-in-out duration-150"
                        placeholder="Phone"
                        required
                      />
                    </div>
                  </div>
                  <div>
                    <label for="conrtact_message" class="sr-only">
                      Message
                    </label>
                    <div class="relative rounded-md shadow-sm">
                      <textarea
                        id="contact_message"
                        name="message"
                        type="text"
                        onChange={handleChange}
                        rows="4"
                        class="form-input block w-full py-4 px-4 placeholder-gray-500 transition ease-in-out duration-150"
                        placeholder="Message"
                        required
                      ></textarea>
                    </div>
                  </div>

                  {SubmitDisabled === true ? (
                    <div>
                      <button
                        type="submit"
                        class="mt-3 rounded-lg text-white sm:mt-0 sm:flex-shrink-0 bg-red px-20 py-3 hover:bg-darkRed transition ease-in duration-200"
                      >
                        Please Wait....
                      </button>
                    </div>
                  ) : (
                    <div>
                      <button
                        type="submit"
                        class="mt-3 rounded-lg text-white sm:mt-0 sm:flex-shrink-0 bg-red px-20 py-3 hover:bg-darkRed transition ease-in duration-200"
                      >
                        Submit
                      </button>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default Support;
